import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NtsAppRootComponent } from '@nts/std';

@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends NtsAppRootComponent {

}
